import { useParams } from "react-router-dom";
import React from "react";
import { cartItemModel, userModel } from "../Interfaces";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../Storage/Redux/store";
import { useUpdateShoppingCartMutation } from "../Apis/shoppingCartApi";
import { removeFromCart } from "../Storage/Redux/shoppingCartSlice";

let confirmedImage = require("../Assests/Images/confirmed.jpg");
function OrderConfirmed() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [updateShoppingCart] = useUpdateShoppingCartMutation();
  const shoppingCartFromStore: cartItemModel[] = useSelector(
    (state: RootState) => state.shoppingCartStore.cartItems ?? []
  );

  const userData: userModel = useSelector(
    (state: RootState) => state.userAuthStore
  );
  let i: number;
  for(i=0;i<shoppingCartFromStore.length;i++)
  {
    updateShoppingCart({
      menuItemId: shoppingCartFromStore[i].menuItem?.id,
      updateQuantityBy: 0,
      userId: userData.id,
    });
    let cartItem: cartItemModel = shoppingCartFromStore[i];
    dispatch(removeFromCart({ cartItem, quantity: 0 })); 
  }
   
  return (
    <div className="w-100 text-center d-flex justify-content-center align-items-center">
      <div>
        <i
          style={{ fontSize: "7rem" }}
          className="bi bi-check2-circle text-success"
        ></i>
        <div className="pb-5">
          <h2 className="text-success mx-auto">Order has been Confirmed!</h2>
          <h5 className="mt-3">Your order ID: {id}</h5>
          <p>We will soon start to cook the delicous food you ordered. </p>
          <div className=" d-none d-md-block d-lg-block d-xl-block">
          <iframe src="https://giphy.com/embed/nqtA5obHo3CSelfeKS" width="480" height="270" className="giphy-embed " style={{pointerEvents: "none"}}></iframe>
          {/* <img
            src="https://res.cloudinary.com/vcart/image/upload/v1676734445/pasigo/Pizza_maker_hvl8he.gif"
            style={{ width: "40%", borderRadius: "30px" }}
          ></img> */}
          </div>
          <div className="mt-4 d-block d-md-none d-lg-none d-xl-none">
          {/* <iframe src="https://giphy.com/embed/nqtA5obHo3CSelfeKS" className="giphy-embed w-100" style={{pointerEvents: "none"}}></iframe> */}
          <img
            src="https://res.cloudinary.com/vcart/image/upload/v1676734445/pasigo/Pizza_maker_hvl8he.gif"
            style={{ width: "100%", borderRadius: "30px" }}
          ></img> 
          </div>
        </div>
      </div>
    </div>
  );
}

export default OrderConfirmed;